import React, { Fragment, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { supabase } from '../../lib/supabaseClient';
import Navbar from '../../component/Other/Navbar';
import Footer from '../../component/Other/Footer';

const PLAN_LABELS = {
  basic: { label: 'Básico', color: '#6c757d', bg: '#f8f9fa' },
  plus: { label: 'Plus', color: 'rgb(17, 112, 223)', bg: 'rgba(17, 112, 223, 0.08)' },
  premium: { label: 'Premium', color: '#005bb5', bg: 'rgba(0, 91, 181, 0.1)' },
};

const Perfil = () => {
  const { user, signOut } = useAuth();
  const [profile, setProfile] = useState(null);
  const [subscription, setSubscription] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user || !supabase) { setLoading(false); return; }

    Promise.all([
      supabase
        .from('users')
        .select('name, email, phone, document_id, avatar_url')
        .eq('id', user.id)
        .maybeSingle(),
      supabase
        .from('subscriptions')
        .select('plan_type, end_date, status')
        .eq('user_id', user.id)
        .eq('status', 'active')
        .order('created_at', { ascending: false })
        .limit(1),
    ]).then(([{ data: userData }, { data: subData }]) => {
      setProfile(userData);
      setSubscription(subData && subData.length > 0 ? subData[0] : null);
      setLoading(false);
    });
  }, [user]);

  if (!user) {
    return (
      <Fragment>
        <div className="overflow-hidden font-poppins">
          <div className="bg__blue-2"><Navbar /></div>
          <img src="./../images/Subtract.png" className="w-100 img-cover" alt="" />
          <section className="py-5">
            <div className="container text-center">
              <p className="medium font__size--18">Debes iniciar sesión para ver tu perfil.</p>
              <NavLink to="/" className="btn btn__purple color__white rounded__12 px-4 semi-bold font__size--14">Ir al inicio</NavLink>
            </div>
          </section>
          <Footer />
        </div>
      </Fragment>
    );
  }

  const createdAt = user.created_at
    ? new Date(user.created_at).toLocaleDateString('es-CO', { year: 'numeric', month: 'long', day: 'numeric' })
    : null;

  const planKey = subscription?.plan_type?.toLowerCase();
  const planInfo = PLAN_LABELS[planKey];
  const planExpiry = subscription?.end_date
    ? new Date(subscription.end_date).toLocaleDateString('es-CO', { year: 'numeric', month: 'long', day: 'numeric' })
    : null;

  const displayName = profile?.name || user.email;
  const avatarUrl = profile?.avatar_url;

  return (
    <Fragment>
      <div className="overflow-hidden font-poppins">
        <div className="bg__blue-2"><Navbar /></div>
        <img src="./../images/Subtract.png" className="w-100 img-cover" alt="" />

        <section className="py-5">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-7">

                {/* Cabecera con foto */}
                <div className="d-flex align-items-center mb-5">
                  {avatarUrl ? (
                    <img
                      src={avatarUrl}
                      alt="Foto de perfil"
                      className="rounded-circle mr-4 flex-shrink-0"
                      style={{ width: 72, height: 72, objectFit: 'cover', border: '3px solid rgba(17,112,223,0.2)' }}
                    />
                  ) : (
                    <div
                      className="d-flex align-items-center justify-content-center rounded-circle mr-4 flex-shrink-0"
                      style={{ width: 72, height: 72, background: 'rgba(17,112,223,0.12)', fontSize: 32 }}
                    >
                      👤
                    </div>
                  )}
                  <div>
                    <h1 className="semi-bold font__size--32 text__32-1024 mb-1">{displayName}</h1>
                    <p className="medium font__size--14 color__gray-1 mb-0">{user.email}</p>
                  </div>
                </div>

                {/* Tarjeta datos de cuenta */}
                <div className="rounded__12 border p-4 mb-4 shadow-sm bg-white">
                  <h5 className="semi-bold font__size--18 mb-3">Datos de la cuenta</h5>
                  {loading ? (
                    <p className="medium font__size--14 color__gray-1">Cargando...</p>
                  ) : (
                    <div className="row">
                      <div className="col-sm-6 mb-3">
                        <p className="semi-bold font__size--13 color__gray-1 mb-1" style={{ textTransform: 'uppercase', letterSpacing: '0.05em' }}>Correo electrónico</p>
                        <p className="medium font__size--15 mb-0">{profile?.email || user.email}</p>
                      </div>
                      {profile?.name && (
                        <div className="col-sm-6 mb-3">
                          <p className="semi-bold font__size--13 color__gray-1 mb-1" style={{ textTransform: 'uppercase', letterSpacing: '0.05em' }}>Nombre / Empresa</p>
                          <p className="medium font__size--15 mb-0">{profile.name}</p>
                        </div>
                      )}
                      {profile?.document_id && (
                        <div className="col-sm-6 mb-3">
                          <p className="semi-bold font__size--13 color__gray-1 mb-1" style={{ textTransform: 'uppercase', letterSpacing: '0.05em' }}>NIT / Cédula</p>
                          <p className="medium font__size--15 mb-0">{profile.document_id}</p>
                        </div>
                      )}
                      {profile?.phone && (
                        <div className="col-sm-6 mb-3">
                          <p className="semi-bold font__size--13 color__gray-1 mb-1" style={{ textTransform: 'uppercase', letterSpacing: '0.05em' }}>Teléfono</p>
                          <p className="medium font__size--15 mb-0">{profile.phone}</p>
                        </div>
                      )}
                      {createdAt && (
                        <div className="col-sm-6 mb-3">
                          <p className="semi-bold font__size--13 color__gray-1 mb-1" style={{ textTransform: 'uppercase', letterSpacing: '0.05em' }}>Miembro desde</p>
                          <p className="medium font__size--15 mb-0">{createdAt}</p>
                        </div>
                      )}
                    </div>
                  )}
                </div>

                {/* Tarjeta plan actual */}
                <div className="rounded__12 border p-4 mb-4 shadow-sm bg-white">
                  <h5 className="semi-bold font__size--18 mb-3">Plan actual</h5>

                  {loading ? (
                    <p className="medium font__size--14 color__gray-1">Cargando...</p>
                  ) : planInfo ? (
                    <div>
                      <div
                        className="d-inline-flex align-items-center rounded-pill px-4 py-2 mb-3"
                        style={{ background: planInfo.bg, border: `2px solid ${planInfo.color}` }}
                      >
                        <span className="semi-bold font__size--16" style={{ color: planInfo.color }}>
                          ✅ Plan {planInfo.label}
                        </span>
                      </div>
                      {planExpiry && (
                        <p className="medium font__size--14 color__gray-1 mb-0">
                          Vigente hasta: <strong>{planExpiry}</strong>
                        </p>
                      )}
                    </div>
                  ) : (
                    <div>
                      <p className="medium font__size--14 color__gray-1 mb-3">
                        No tienes un plan activo en este momento.<br />
                        Si ya pagaste, tu plan se activará automáticamente en la app en los próximos minutos.
                      </p>
                      <NavLink
                        to="/planes"
                        className="btn btn__purple color__white rounded__12 px-4 semi-bold font__size--14 text-decoration-none"
                      >
                        Ver planes
                      </NavLink>
                    </div>
                  )}
                </div>

                {/* Cerrar sesión */}
                <div className="text-right">
                  <button
                    onClick={signOut}
                    className="btn medium font__size--14 rounded__12 px-4"
                    style={{ border: '2px solid #dc3545', color: '#dc3545', background: 'transparent' }}
                  >
                    Cerrar sesión
                  </button>
                </div>

              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </Fragment>
  );
};

export default Perfil;
